import useCookieDeclaration from "hooks/useCookieDeclaration";

export default function CookiesBA() {
  useCookieDeclaration({ slotId: "cookie-declaration-slot-ba", culture: "bs" });

  return (
    <div className="hero hero__secondary position-relative bg-white px-2 px-sm-0">
      <div className="container narrow bg-white rounded-5 p-md-5">
        <div class="cook">
          <h1>Kolačići</h1>
          <p>
            Na va&scaron; računar mora se sačuvati minimalna količina
            informacija (kolačići) da bi web-stranica pravilno radila i da bismo
            je mogli nadograđivati i unapređivati va&scaron;e iskustvo tokom
            pregledanja. Vi&scaron;e od 90% web-stranica upotrebljava kolačiće,
            ali prema pravilima Evropske unije moraju korisnika zamoliti za
            pristanak. Upotrebom ove web-stranice izražavate svoju saglasnost s
            upotrebom kolačića, a ako ih ne prihvatite, i dalje možete
            pregledati stranicu, ali se određene funkcije na njoj možda neće
            pravilno prikazati ili izvr&scaron;iti.
          </p>
          <h2>Pravila upotrebe kolačića</h2>
          <p>
            Na va&scaron; računar mora se sačuvati minimalna količina
            informacija (kolačići) da bi web-stranica pravilno radila i da bismo
            je mogli nadograđivati i unapređivati va&scaron;e iskustvo tokom
            pregledanja. Vi&scaron;e od 90% web-stranica upotrebljava kolačiće,
            ali prema pravilima Evropske unije moraju korisnika zamoliti za
            pristanak. Upotrebom ove web-stranice izražavate svoju saglasnost s
            upotrebom kolačića, a ako ih ne prihvatite, i dalje možete
            pregledati stranicu, ali se određene funkcije na njoj možda neće
            pravilno prikazati ili izvr&scaron;iti.
          </p>
          <h3>&Scaron;ta je kolačić?</h3>
          <p>
            Kolačić je informacija koju na va&scaron; računar postavlja
            web-stranica koju ste posjetili. Kolačići obično čuvaju va&scaron;e
            postavke za web-stranicu, na primjer željeni jezik ili adresu.
            Kasnije, kada ponovo otvorite istu web-stranicu, pregledač vraća
            kolačiće koji joj pripadaju. To stranici omogućava da prikaže
            informacije prilagođene va&scaron;im potrebama.
          </p>
          <p>
            Kolačići mogu čuvati niz informacija, uključujući lične informacije
            (va&scaron;e ime ili e-po&scaron;tu). Uprkos tome ta informacija
            može se sačuvati samo u slučaju da to vi omogućite &ndash;
            web-stranice ne mogu pristupiti informacijama ako vi to niste
            odobrili, a ne mogu ni pristupiti drugim datotekama na va&scaron;em
            računaru ili mobilnom uređaju. Podrazumijevane postavke čuvanja i
            slanja kolačića vama nisu vidljive, ali možete promijeniti postavke
            svog pregledača tako da sami izaberete da li želite odobriti ili
            odbiti zahtjeve za čuvanje kolačića, automatski izbrisati sačuvane
            kolačiće prilikom zatvaranja pregledača i slično.
          </p>
          <h3>Kako možete odbiti kolačiće?</h3>
          <p>
            Odbijanjem kolačića odlučujete da li želite dozvoliti da se kolačići
            sačuvaju na va&scaron;em računaru ili mobilnom uređaju. Postavke
            kolačića mogu se kontrolisati i konfigurisati u va&scaron;em
            pregledaču. Ako kolačiće ne prihvatite, može se dogoditi da nećete
            moći upotrebljavati određene funkcije na web-stranici.
          </p>
          <h3>&Scaron;ta su to privremeni kolačići?</h3>
          <p>
            Privremeni kolačići ili kolačići za sesiju bri&scaron;u se s
            računara nakon zatvaranja pregledača. Uz njihovu pomoć web-lokacije
            čuvaju privremene podatke, na primjer proizvode u korpi za
            kupovanje.
          </p>
          <p>
            <strong>&Scaron;ta su to trajni kolačići?</strong>
          </p>
          <p>
            Trajni ili sačuvani kolačići ostaju na računaru i nakon &scaron;to
            zatvorite program pregledača. Uz njihovu pomoć web-lokacije čuvaju
            podatke kao &scaron;to su korisničko ime i lozinka, tako da se ne
            morate prijavljivati prilikom svakog posjećivanja određene
            web-lokacije. Trajni kolačići ostat će na računaru vi&scaron;e dana,
            mjeseci ili čak godina.
          </p>
          <p>
            <strong>&Scaron;ta su to kolačići prve strane?</strong>
          </p>
          <p>
            Kolačići prve strane (vlastiti kolačići) potječu sa web-lokacije
            koju korisnik pregleda i mogu biti trajni ili privremeni. Pomoću tih
            kolačića web-lokacije mogu sačuvati podatke koje će ponovo
            upotrijebiti kada korisnik sljedeći put posjeti tu lokaciju.
          </p>
          <p>
            <strong>&Scaron;ta su to kolačići treće strane?</strong>
          </p>
          <p>
            Kolačići treće strane (drugi kolačići) potječu sa drugih,
            partnerskih web-lokacija (kao &scaron;to su skočni prozori ili druge
            reklame), koji se nalaze na web-lokaciji koje pregledate. Pomoću tih
            kolačića web-lokacije mogu pratiti upotrebu interneta u
            trži&scaron;ne svrhe.
          </p>
          <p>
            <strong>Da li ova stranica upotrebljava kolačiće?</strong>
          </p>
          <p>
            Da, s primarnim ciljem da vam na&scaron;e web-stranice omoguće
            najbolje korisničko iskustvo.
          </p>
          <p>
            <strong>
              Kakve kolačiće upotrebljava ova web-stranica i za&scaron;to?
            </strong>
          </p>
          <p>
            Privremeni kolačići ili kolačići za sesiju (Session cookies) &ndash;
            su kolačići koji istječu (i automatski se bri&scaron;u) kada
            zatvorite pregledač. Mi upotrebljavamo privremene kolačiće kako bi
            korisnik dobio najbolje iskustvo prilikom upotrebe na&scaron;e
            web-stranice.
          </p>
          <p>
            Trajni ili sačuvani kolačići (Persistent cookies) njihov datum
            isteka obično je daleko u budućnosti, zato će ostati u va&scaron;em
            pregledaču dok ne isteknu ili dok ih ručno ne izbri&scaron;ete. Mi
            upotrebljavamo trajne kolačiće da bismo bolje shvatili navike
            korisnika, a time možemo pobolj&scaron;ati web-stranicu zavisno od
            va&scaron;ih navika. Na osnovi tako prikupljenih podataka nije
            moguća identifikacija vas kao korisnika, a prikupljeni podaci
            upotrebljavaju se isključivo u statističke svrhe.
          </p>
          <p>
            <strong>
              Da li na web-stranici postoje kolačići treće strane?
            </strong>
          </p>
          <p>
            Postoji vi&scaron;e vanjskih servisa koji za korisnika čuvaju
            ograničene kolačiće. Te kolačiće nije postavila ova web-stranica,
            ali neki od njih služe za normalan rad određenih funkcija koje
            korisnicima olak&scaron;avaju pristup sadržaju. Zbog toga
            informacije o za&scaron;titi podataka s kojima se ovdje upoznajete
            važe samo za ovu web-stranicu, a za&scaron;titu podataka na vanjskim
            servisima treba provjeriti na njihovim službenim stranicama.
          </p>
          <p>
            <strong>Trenutno omogućavamo:</strong>
          </p>
          <p>
            <strong>Mjerenje posjeta</strong>
          </p>
          <p>
            Ova web-stranica upotrebljava servise za mjerenje broja korisnika, i
            to Google Analytics. Na osnovi tako prikupljenih podataka nije
            moguća identifikacija korisnika, a prikupljeni podaci upotrebljavaju
            se isključivo u statističke svrhe. Ako želite spriječiti da vam
            navedeni servisi &scaron;alju kolačiće, za svaki servis ih možete
            odbiti na sljedećim vezama:
          </p>
          <ul>
            <li>
              <p>
                Google Analytics &ndash;&nbsp;
                <a href="https://tools.google.com/dlpage/gaoptout">
                  https://tools.google.com/dlpage/gaoptout
                </a>
              </p>
            </li>
          </ul>
          <h3>Dodatne informacije o odbijanju kolačića</h3>
          <p>
            Trenutno postoji vi&scaron;e web-stranica za odbijanje čuvanja
            kolačića za različite servise.
          </p>
          <p>Vi&scaron;e o tome možete saznati na sljedećim vezama:</p>
          <ul>
            <li>
              <p>
                <a href="http://www.allaboutcookies.org/">
                  http://www.allaboutcookies.org/
                </a>
              </p>
            </li>
            <li>
              <p>
                <a href="http://www.youronlinechoices.eu/">
                  http://www.youronlinechoices.eu/
                </a>
              </p>
            </li>
          </ul>
          <div id="cookie-declaration-slot-ba" />
          {/*           <table className="CookieDeclarationTable">
            <colgroup>
              <col style={{ width: "20%" }} />
              <col style={{ width: "20%" }} />
              <col style={{ width: "35%" }} />
              <col style={{ width: "15%" }} />
              <col style={{ width: "10%" }} />
            </colgroup>
            <thead>
              <tr>
                <th
                  scope="col"
                  className="CookieDeclarationTableHeader"
                  dir="ltr">
                  Naziv
                </th>
                <th
                  scope="col"
                  className="CookieDeclarationTableHeader"
                  dir="ltr">
                  Pružalac
                </th>
                <th
                  scope="col"
                  className="CookieDeclarationTableHeader"
                  dir="ltr">
                  Svrha
                </th>
                <th
                  scope="col"
                  className="CookieDeclarationTableHeader"
                  dir="ltr">
                  Maksimalno trajanje čuvanja
                </th>
                <th
                  scope="col"
                  className="CookieDeclarationTableHeader"
                  dir="ltr">
                  Tip
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="CookieDeclarationTableCell">
                  CookieConsent [x2]
                </td>
                <td className="CookieDeclarationTableCell">
                  sgtm.argeta.com
                  <br />
                  <a
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    href="https://www.cookiebot.com/goto/privacy-policy/"
                    title="Politika zasebnosti za Cookiebot">
                    Cookiebot
                  </a>
                </td>
                <td className="CookieDeclarationTableCell">
                  Stores the user&apos;s cookie consent state for the current
                  domain
                </td>
                <td className="CookieDeclarationTableCell">1 year</td>
                <td className="CookieDeclarationTableCell">HTTP cookie</td>
              </tr>
              <tr>
                <td className="CookieDeclarationTableCell">test_cookie</td>
                <td className="CookieDeclarationTableCell">
                  <a
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    href="https://business.safety.google/privacy/"
                    title="Politika zasebnosti za Google">
                    Google
                  </a>
                </td>
                <td className="CookieDeclarationTableCell">
                  Used to check if the user&apos;s browser supports cookies.
                </td>
                <td className="CookieDeclarationTableCell">1 day</td>
                <td className="CookieDeclarationTableCell">HTTP cookie</td>
              </tr>
            </tbody>
          </table> */}
        </div>
      </div>
    </div>
  );
}
